import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles({
  card: {
    maxWidth: "725px",
    margin: "30px auto",
    borderRadius: "16px",
    border: "1px solid" + colors.lightGrey,
    backgroundColor: colors.white,
    boxShadow: "0 12px 16px -4px rgba(16, 24, 40, 0.08), 0 4px 6px -2px rgba(16, 24, 40, 0.03)",
    overflow: "hidden",
  },
  title: {
    margin: "0 0 8px 0",
    color: colors.lightBlack,
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "28px",
  },
  subtitle: {
    color: colors.mediumGrey,
    fontWeight: "400",
    fontSize: "18px",
    margin: 0,
    lineHeight: "28px",
  },
  headerBanner: {
    backgroundColor: colors.mustardYellow,
    height: "20px",
  },
  content: {
    padding: "32px",
  },
  ulLists: {
    padding: 0
  },
  titleContainer: {
    color: colors.grey,
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "28px",
    paddingBottom: "32px"
  },
  sections: {
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
     [`@media (max-width: ${breakpoints.sm}px)`]: {
      display: "grid"
    },
  },
  section: {
    flex: 1,
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: "16px",
    fontSize: "16px",
    color: colors.mediumGrey
  },
  priceText: {
    fontWeight: 600,
    fontSize: "16px",
    color: colors.lightBlack,
    marginBottom: "6px"
  },
  explorePackage: {
    textDecoration: "none",
    color: colors.white,
    fontWeight: "600",
    padding: "10px 18px",
    fontSize: "16px",
    backgroundColor: colors.primary700Blue,
    borderRadius: "8px"
  },
  listItem: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "15px",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "400",
    "& svg": {
      marginRight: "10px",
      marginTop: "3px",
      flexShrink: 0,
      fontSize: "16px",
      "& path": {
        fill: colors.mustardYellow
      }
    }
  },
  boldedText: {
    display: "contents",
    fontWeight: "600"
  },
  footer: {
    padding: "20px 25px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: colors.brightBlue,
  },
  price: {
    fontSize: "24px",
    fontWeight: 600,
    color: colors.lightBlack,
    lineHeight: "24px",
  },
  moreLink: {
    textAlign: "center",
    marginTop: "16px",
    fontSize: "16px",
    color: colors.paleGrey,
    fontStyle: "italic"
  },
});

export default styles;
